import { Typography } from '@mui/material';
import {
  BooleanInput,
  Edit,
  Labeled,
  NumberField,
  SimpleForm,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import { Category } from '../types';
import { BaseItemEdit } from './BaseItemEdit';

export const ItemEdit = () => {
  return (
    <Edit title={<CategoryTitle />}>
      <SimpleForm>
        <Labeled>
          <NumberField source="id" />
        </Labeled>
        <BaseItemEdit />
        <BooleanInput source="Active" />
      </SimpleForm>
    </Edit>
  );
};

const CategoryTitle = () => {
  const translate = useTranslate();
  const record = useRecordContext<Category>();
  return (
    <Typography>
      {translate('resources.items.title', {
        id: record ? `#${record.id}` : '',
        name: record?.Name,
      })}
    </Typography>
  );
};
